module.exports = __webpack_public_path__ + "static/media/tarja-linhas-retok.84a0d6c5.jpg";